export const normalizeBookings = (data) => {
  if (Array.isArray(data)) return data;
  return data?.bookings || data?.items || [];
};

export const filterBookings = (bookings, searchTerm) => {
  const term = searchTerm.trim().toLowerCase();
  if (!term) return bookings;

  return bookings.filter((booking) => {
    const searchableText = [
      booking?.bookingId,
      booking?.tourId,
      booking?.status,
      booking?.fullName,
      booking?.companyName,
      booking?.phoneNumber,
      booking?.email,
      booking?.pickupLocation,
      booking?.dropoffLocation,
      booking?.customerSnapshot?.name,
      booking?.customerSnapshot?.companyName,
      booking?.customerSnapshot?.phoneNumber,
      booking?.customerSnapshot?.email,
      booking?.customerSnapshot?.companyName,
      booking?.paymentStatus,
      booking?.paymentDetails?.transactionId,
      booking?.paymentDetails?.reference,
      booking?.paymentDetails?.method,
      booking?.vehicles
        ?.map((vehicle) => [
          vehicle?.snapshot?.name,
          vehicle?.vehicleId?.name,
          vehicle?.snapshot?.make,
          vehicle?.snapshot?.model,
          vehicle?.vehicleId?.make,
          vehicle?.vehicleId?.model,
          vehicle?.packageId?.name,
          vehicle?.snapshot?.packageName,
          vehicle?.vehicleId?._id,
          vehicle?.vehicleId?.id,
        ])
        .flat(),
      booking?.driverAssignments
        ?.map((assignment) => [
          assignment?.driverSnapshot?.name,
          assignment?.driverSnapshot?.contactNumber,
          assignment?.driverSnapshot?.licenseNumber,
          assignment?.driverId?.name,
          assignment?.driverId?.contactNumber,
          assignment?.driverId?.licenseNumber,
          assignment?.vehicleId,
        ])
        .flat(),
    ]
      .flat()
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    return searchableText.includes(term);
  });
};

export const formatBookingDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";

  return new Intl.DateTimeFormat("en-PK", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
};

export const formatBookingAmount = (amount) => {
  const numericAmount = Number(amount);
  if (!Number.isFinite(numericAmount)) return "-";
  return new Intl.NumberFormat("en-PK", {
    style: "currency",
    currency: "PKR",
    maximumFractionDigits: 0,
  }).format(numericAmount);
};

export const getBookingStatusBadgeClass = (status) => {
  if (status === "completed") return "badge bg-success";
  if (status === "pending") return "badge bg-warning text-dark";
  if (status === "in_progress") return "badge bg-primary";
  if (status === "cancelled") return "badge bg-danger";
  return "badge bg-secondary";
};
